import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  const navItems = [
    { label: 'Our Services', id: 'services' },
    { label: 'How It Works', id: 'how-it-works' },
    { label: 'About Us', id: 'about' },
    { label: 'Contact', id: 'contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-sm' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
        <div className="flex items-center gap-2">
          <img
            src="https://static.readdy.ai/image/cf33c51050e95588e8f90f230098c778/2e85fd3c1c61935d17af19cdb38ff5c1.jpeg"
            alt="Aligned Home Care logo"
            className="h-10 w-10 object-contain rounded-full bg-white p-0.5"
          />
          <div className="flex flex-col leading-tight">
            <span
              className={`text-base font-bold tracking-tight transition-colors duration-300 ${scrolled ? 'text-[#2C3E50]' : 'text-white'}`}
            >
              Aligned
            </span>
            <span className="text-[10px] font-semibold tracking-[0.18em] uppercase text-[#C0706A]">
              Home Care
            </span>
          </div>
        </div>

        <ul className="hidden md:flex items-center gap-7">
          {navItems.map((item) => (
            <li key={item.id}>
              <button
                onClick={() => scrollTo(item.id)}
                className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-[#C0706A] ${scrolled ? 'text-[#2C3E50]' : 'text-white/80'}`}
              >
                {item.label}
              </button>
            </li>
          ))}
          <li>
            <Link
              to="/policy"
              className={`text-sm font-medium transition-colors duration-200 cursor-pointer whitespace-nowrap hover:text-[#C0706A] ${scrolled ? 'text-[#2C3E50]' : 'text-white/80'}`}
            >
              Policies
            </Link>
          </li>
        </ul>

        <button
          onClick={() => scrollTo('contact')}
          className="hidden md:block bg-[#C0706A] hover:bg-[#a85f59] text-white text-sm font-bold px-5 py-2.5 rounded-full transition-colors duration-200 whitespace-nowrap cursor-pointer"
        >
          Book a Call
        </button>

        <div className="md:hidden flex items-center gap-2">
          <a
            href="tel:01312100021"
            className={`w-8 h-8 flex items-center justify-center rounded-full transition-colors duration-300 cursor-pointer ${scrolled ? 'bg-[#2C3E50]/10 text-[#2C3E50]' : 'bg-white/15 text-white'}`}
          >
            <i className="ri-phone-line text-base"></i>
          </a>
          <button
            className={`w-8 h-8 flex items-center justify-center cursor-pointer transition-colors duration-300 ${scrolled ? 'text-[#2C3E50]' : 'text-white'}`}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`text-xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-white border-t border-[#2C3E50]/10 px-6 py-4 flex flex-col gap-4">
          {navItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollTo(item.id)}
              className="text-sm font-medium text-[#2C3E50] hover:text-[#C0706A] text-left cursor-pointer whitespace-nowrap"
            >
              {item.label}
            </button>
          ))}
          <Link
            to="/policy"
            onClick={() => setMenuOpen(false)}
            className="text-sm font-medium text-[#2C3E50] hover:text-[#C0706A] transition-colors cursor-pointer whitespace-nowrap text-left"
          >
            Policies
          </Link>
          <button
            onClick={() => scrollTo('contact')}
            className="bg-[#C0706A] text-white text-sm font-bold px-5 py-2.5 rounded-full w-full cursor-pointer whitespace-nowrap"
          >
            Book a Call
          </button>
        </div>
      )}
    </nav>
  );
}
